<template>
  <div>
    <b-container class="p-0">
      <b-row>
        <b-col>
          <b-card class="border-0">
            <b-form @submit="onSubmitNewProjectInfo" @reset="resetForm">
              <fieldset>
                <b-form-row>
                  <b-col sm="12" md="6" lg="6">
                     <b-form-group id="Indtast håndværkerens firma" description="" label="Firma" name="Firma" class="font-weight-bold">
                       <b-form-input type="text" required v-model="newproject.company" class="rounded"></b-form-input>
                     </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" lg="6">
                    <b-form-group id="" description="Indtast håndværkerens navn" label="Navn" name="Navn" class="font-weight-bold">
                      <b-form-input type="text" required v-model="newproject.name" class="rounded"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" lg="6">
                    <b-form-group id="" description="Indtast håndværkerens telefonnummer" label="Tlf." name="Tel"  class="font-weight-bold">
                      <b-form-input type="tel" required autocomplete="tel" v-model="newproject.tel" class="rounded"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" lg="6">
                    <b-form-group id="" description="Indtast håndværkerens e-mail" label="E-mail" name="Email" class="font-weight-bold">
                      <b-form-input type="email" required autocomplete="email" v-model="newproject.email" class="rounded"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" lg="6">
                    <b-form-group>
                      <b-form-row>
                        <b-col>
                          <b-button variant="primary" type="submit" class="rounded mr-2" size="lg">
                            <span class="mr2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.004 3h2.996v5h-2.996v-5zm8.996 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9zm-2 2h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z"/></svg></span>Gem
                          </b-button>
                        </b-col>
                      </b-form-row>
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </fieldset>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <div class="py-4"></div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>

</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'projectlist',
  props: ['projects', 'projects_create'],
  components: {
    loading,
    Simplert
  },
  data () {
    return {
      newproject: {
        company: '',
        name: '',
        tel: '',
        email: ''
      },
      show: false,
      label: 'Loading...',
      overlay: true,
      haaId: '',
      salesPerson: ''
    }
  },
  created () {
    this.Reload()
  },
  methods: {
    clearForm () {
      alert('ggg')
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'myCenterInfo', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.$emit('UpdateProject', res.projects, res.projects_create)
          },
          response => {
            alert('error')
          }
        )
    },
    onSubmitNewProjectInfo (evt) {
      evt.preventDefault()
      if (this.projects_create >= this.projects) {
        let obj = {
          title: 'Fejl',
          message: 'Du skal købe flere projektor',
          type: 'error'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = { operation: 'addCenter', salesPerson: this.salesPerson, levid: this.haaId, customer: JSON.stringify(this.newproject) }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              let closeFn = function () {
                this.$parent.newproject.company = ''
                this.$parent.newproject.name = ''
                this.$parent.newproject.tel = ''
                this.$parent.newproject.email = ''
                this.Reload()
              }
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                onClose: closeFn
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              let obj = {
                title: 'Fejl',
                message: 'Fejl - Kontakt venligst administrator',
                type: 'error'
              }
              this.$refs.simplert.openSimplert(obj)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    resetForm (evt) {
      evt.preventDefault()
      Object.assign(this.$data, this.$options.data.call(this))
    },
    buyProjects () {
      this.$router.push('/koeb-projekter')
    }
  }
}
</script>
<style scoped>
legend > span {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// ProducenterAddProject.vue?617e2ea2